import { IChargePoint } from '../common/hooks/useChargePoint'
import { ChargePoint } from '../common/redux/api/web-api'

const isOnline = (chargePoint: IChargePoint | ChargePoint): boolean => chargePoint?.chargePointStatus === 'Online'

export default isOnline
